import autocomplete from 'autocompleter';

/**
 * duengung_autocompleteAufzeichnung
 * @param elementID
 * @param helperFile
 * @param einsatzdatumStart
 */
window.duengung_autocompleteAufzeichnung = function(elementID, helperFile, einsatzdatumStart = '') {
  // input
  const input = document.getElementById(elementID);
  input.setAttribute('autocomplete', 'off');

  const row = $(input).closest('div.psm-mittel-row');
  const recordID = $('#app__content').data('id');

  $(input).on('keyup', function() {
    if ($(this).val() === '') {
      duengung_bindClearMittel();
    }
  });

  autocomplete({
    emptyMsg: LANG_STRINGS.noResults,
    minLength: 1,
    input: input,
    preventSubmit: true,
    debounceWaitMs: 300,
    className: 'autocomplete-additional',
    fetch: function(text, update) {
      if ($(input).hasClass('readonly')) {
        return false;
      }

      text = text.toLowerCase();

      let selectedSpritzmittel = [];
      let selectedDuengemittel = [];
      let selectedSections = [];

      $('#table-mittel').find('div.row:not(.row-table__head)').each(function() {
        if ($(this).data('psm-key') === 'psm' && $(this).data('psm-id') !== '') {
          selectedSpritzmittel.push($(this).data('psm-id'));
        } else if ($(this).data('psm-key') === 'duenge' && $(this).data('psm-id') !== '') {
          selectedDuengemittel.push($(this).data('psm-id'));
        }
      });

      $.each($('input.check_section:checked'), function() {
        selectedSections.push($(this).val());
      });
      // Ajax-Call
      $.ajax({
        url: BASE_PATH + 'ajax/autocomplete/' + helperFile,
        type: 'post',
        data: {
          type: elementID,
          search: text,
          recordID: recordID,
          einsatzdatumStart: einsatzdatumStart,
          selectedSections: selectedSections,
          excludeSpritzmittel: selectedSpritzmittel,
          excludeDuengemittel: selectedDuengemittel,
        },
        dataType: 'json',
        success: function(response) {
          let suggestions = Array();

          $.each(response, function(i, obj) {
            let valueData = Array();
            for (let key in obj) {
              valueData[key] = obj[key];
            }

            suggestions.push({
              'label': valueData['name'],
              'value': valueData,
            });
          });

          const itemCount = suggestions.length;
          if (itemCount === 0) {
            suggestions.push({
              'label': '',
              'value': '',
            });
            update(suggestions);
          }

          update(suggestions);

          // render mittelanfrage
          renderMittelanfrage('.autocomplete-additional', 'duengung');
        },
      });
    },
    render: function(item) {
      let div = document.createElement('div');

      $(div).addClass(item.value.zulassungsstatus_id_css);

      if (item.value.lagerbestand !== undefined) {
        const lagerbestand = (item.value.lagerbestand !== '' ? numberFormatAuto(item.value.lagerbestand, 2, 2) : '-.-');
        const lagerbestandEinheit = item.value.lagerbestand_einheit || '';

        div.innerHTML = '<span class=\'with-lager\'>' + item.label + '</span><span class=\'with-lager\'>' + lagerbestand + ' ' + lagerbestandEinheit + '</span>';
      } else {
        div.innerHTML = item.label;
      }

      return div;
    },
    onSelect: function(item) {
      // zu Beginn die Zeile leeren
      duengung_bindClearMittel();
console.log(item);
      const label = item.label;
      const tempLabel = label.replace(/<strong>/gi, '');
      const temp = tempLabel.replace(/<\/strong>/gi, '');

      const valueData = item.value;
      const mittelID = valueData['uid'];
      const url = valueData['psm_url'];

      input.label = temp;
      input.value = temp;

      row.attr('data-key', valueData.dataKey);
      row.find('.data_key').val(valueData.dataKey);
      row.find('input.psm_uid').val(mittelID);
      row.find('input.ce_group').val(valueData.ceGroup);

      // Einheit
      let countEinheit = 0;
      let firstEinheit;
      $.each(valueData.psm_dosage_unity_names_and_ids, function(key, value) {
        countEinheit++;

        firstEinheit = value;
        return false;
      });

      row.find('.spray-amount-unity').val(firstEinheit.code);

      row.find('.sumMengeGesamtGui').removeAttr('readonly');
      row.find('.sumMengeGesamtGui').closest('label').find('span.icon-after').html(firstEinheit.name);

      row.find('.sumMengeHaGui').removeAttr('readonly');
      row.find('.sumMengeHaGui').closest('label').find('span.icon-after').html(firstEinheit.name + '/ha');
      row.find('.naehrstoff-input').closest('label').find('span.icon-after').html(firstEinheit.name + '/ha');

      if(Number(valueData.ceGroup) === WIRTSCHAFTSDUENGER_FEST_CE_GROUP || Number(valueData.ceGroup) === WIRTSCHAFTSDUENGER_FLUESSIG_CE_GROUP){
        row.find('.sumMengeGesamtWirtschaftsduengerGui').removeAttr('readonly');
        row.find('.sumMengeGesamtWirtschaftsduengerGui').closest('div.col-xs-12').removeClass('display-none');

        row.find('.sumMengeGesamtGui').attr('readonly', 'readonly');
        row.find('.sumMengeHaGui').attr('readonly', 'readonly');
      }
      const ingredients = valueData.ingredients;
      $.each(ingredients, function(key, value) {
        row.find('div[data-naehrstoff-id="' + value.ingredient_uid + '"]').removeClass('display-none');
        row.find('div[data-naehrstoff-id="' + value.ingredient_uid + '"] input.naehrstoff-prozent').val(reformatNumeric(value.value, 2));
      });

      row.attr('data-psm-id', valueData.uid);
      row.find('.psm_mittel_uid').val(valueData.uid);
      row.find('.psm_mittel_parent_uid').val(valueData.parent_uid);
      row.find('.psm_mittel_archived').val(valueData.archived);

      checkIconAfterLength();

      // Hinweise
      duengung_bindHinweise(recordID, mittelID, valueData.dataKey, 0);

      // Button Database
      $('button#mittel-database-button').attr('data-url', url).removeAttr('disabled');

      // Button Bemerkung
      $('button#mittel-bemerkung-button').removeAttr('disabled');

      // Input Settings
      $(input).attr('readonly', 'readonly');
      $(input).closest('.form-field').removeClass('form-field--error');
      $('#remove-mittel-element').removeClass('display-none');
    },
  });
};

/**
 * duengung_bindHinweise
 * @param recordID
 * @param mittelID
 * @param dataKey
 * @param indicationID
 */
window.duengung_bindHinweise = function(recordID, mittelID, dataKey, indicationID) {
  $('.mittel-hinweise').html('').addClass('display-none');

  // Hinweise
  $.ajax({
    type: 'POST',
    url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getMittelControls?type=duengung',
    async: true,
    data: {
      recordID: recordID,
      psmID: mittelID,
      dataKey: dataKey,
      psmIndication: indicationID,
    },
    success: function(result) {
      if (result !== '') {
        $('.mittel-hinweise').html(result).removeClass('display-none');
      }
    },
  });
};

/**
 * duengung_bindClearMittel
 */
window.duengung_bindClearMittel = function() {
  const row = $('.psm-mittel-row');
  const inputsToClearAndReadable = row.find('.smittel');
  inputsToClearAndReadable.each(function() {
    const input = $(this);
    input.removeAttr('readonly');
    input.removeClass('readonly');
    input.val('');
  });

  const inputsToClear = row.find(
      '.smittel, ' +
      '.psm_mittel_uid, ' +
      '.data_key, ' +
      '.ce_group, ' +
      '.psm_mittel_parent_uid, ' +
      '.psm_mittel_archived, ' +
      '.sumMengeGesamtWirtschaftsduengerGui, ' +
      '.sumMengeGesamtGui, .sumMengeGesamt, ' +
      '.sumMengeHaGui, .sumMengeHa, ' +
      '.naehrstoff-input, .naehrstoff-prozent');
  inputsToClear.each(function() {
    const input = $(this);
    input.val('').removeClass('err');
  });

  const selectsToClear = row.find('select');
  selectsToClear.each(function() {
    const select = $(this);
    select.removeAttr('readonly').removeClass('err').removeClass('readonly');
    select.find('option').remove();
    select.val('').removeClass('err');
  });

  row.find('.smittel').css('cursor', 'auto').removeClass('err');

  // Remove Units
  row.find('.sumMengeGesamtGui').attr('readonly', 'readonly');
  row.find('.sumMengeGesamtGui').closest('label').find('span.icon-after').html('&nbsp;');

  row.find('.sumMengeHaGui').attr('readonly', 'readonly');
  row.find('.sumMengeHaGui').closest('label').find('span.icon-after').html('&nbsp;');

  row.find('.sumMengeGesamtWirtschaftsduengerGui').attr('readonly', 'readonly');
  if(!row.find('.sumMengeGesamtWirtschaftsduengerGui').closest('div.col-xs-12').hasClass('display-none')){
    row.find('.sumMengeGesamtWirtschaftsduengerGui').closest('div.col-xs-12').addClass('display-none')
  }

  row.find('.naehrstoff-input').closest('label').find('span.icon-after').html('&nbsp;');
  row.find('div[data-naehrstoff-id]').addClass('display-none');

  // Button Database
  $('button#mittel-database-button').removeAttr('data-url').attr('disabled', 'disabled');

  // Button Bemerkung
  $('button#mittel-bemerkung-button').attr('disabled', 'disabled').find('i.material-icons').hide();
  $('#mittel-bemerkung-text').val('');

  $('.mittel-hinweise').html('').addClass('display-none');

  row.attr('data-psm-id', '');
  row.attr('data-key', '');
  row.find('.smittel').click();
  row.find('.smittel').focus();

  $('#remove-mittel-element').addClass('display-none');
};

/**
 * duengung_buildMittelRow
 * @param json
 * @param divElement
 */
window.duengung_buildMittelRow = function(json, divElement) {
  // Template
  let template = $('#mittel-row').html();

  $.each(json, function(k, v) {
    if (k === '__BEMERKUNG__') {
      v = v.replace(/<br ?\/?>/g, '\n');
    }
    template = template.replace(new RegExp(k, 'g'), v);
  });

  if ($(divElement).find('div[data-row-key="' + json.__KEY__ + '"]').length > 0) {
    $(divElement).find('div[data-row-key="' + json.__KEY__ + '"]').replaceWith(template);
  } else {
    $(divElement).append(template);
  }
};

/**
 * duengung_buildAbschnittMittelRow
 * @param json
 * @param divElement
 */
window.duengung_buildAbschnittMittelRow = function(json, divElement) {
  const checkedAbschnitte = $(divElement).find('input.check_section[type="checkbox"]:checked');
  if (checkedAbschnitte.length > 0) {
    checkedAbschnitte.each(function() {
      const detailMittel = $(this).closest('.tree-item').find('div.table-mittel-abschnitt');

      // Template
      let template = $('#mittel-abschnitt-row').html();

      $.each(json, function(k, v) {
        template = template.replace(new RegExp(k, 'g'), v);
      });

      template = template.replace(new RegExp('__SECTION_ID__', 'g'), $(this).val());

      if (json.__ROW_ID__ !== '' && detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-row-id="' + json.__ROW_ID__ + '"]').length > 0) {
        detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-row-id="' + json.__ROW_ID__ + '"]').replaceWith(template);
      } else if (detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-psm-id="' + json.__PSM_ID__ + '"][data-psm-key="' + json.__PSM_KEY__ + '"]').length > 0) {
        detailMittel.find('div.row[data-section-uid="' + $(this).val() + '"][data-psm-id="' + json.__PSM_ID__ + '"][data-psm-key="' + json.__PSM_KEY__ + '"]').replaceWith(template);
      } else {
        detailMittel.append(template);
      }
    });
  }
};

/**
 *
 * @param select
 * @param val
 */
window.duengung_changeAusbringungsmethode = function(select, val) {
  const selected = $(select).find(':selected');
  if ($(selected).hasClass('rueckenspritze')) {
    $('#select-ausbringungsmethode').val(val);
  }
};